import React from 'react';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="border-b border-arena bg-crudo" data-id="element-79" data-mp="1i4znmpm6fims">
      <div className="mx-auto max-w-xl px-4 py-6 sm:py-9" data-id="element-80" data-mp="4vrz7ul6w7pa">
        <div className="rounded-2xl border-2 border-olive/60 bg-olive/10 p-4 text-center" data-id="element-81" data-mp="9ttiogmj291a">
          <p className="font-hand text-xl font-bold leading-tight text-olive sm:text-2xl" data-id="element-82" data-mp="et62esi3qzzn">
            Tu inversión está protegida
          </p>
          <h2 id="garantia" className="mt-0.5 font-serif text-2xl text-marron sm:text-3xl" data-id="element-83" data-mp="js0wwrpfmczl">
            🛡️ Garantía total de 7 días
          </h2>
          <p className="mt-1.5 text-sm leading-snug text-marron/80" data-id="element-84" data-mp="sl496woccjsn">
            Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si consideras
            que el sistema no es adecuado para ti, puedes solicitar un reembolso
            dentro del período establecido según los términos de devolución.
          </p>
        </div>
      </div>
    </section>;
}